import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
import ExpenseNoteIcon from "../../Icons/DailyNoteIcon";
import DailyNoteIcon from "../../Icons/DailyNoteIcon";

const DailyNoteComponent = loadable(
  () => import("../../components/DailyNote/DailyNote")
);
const DailyNote = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <DailyNoteIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Daily Note
        </span>
      </div>
      <DailyNoteComponent />
    </>
  );
};

export default DailyNote;
